import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import Sanitize from 'components/media/UserText/Sanitize.jsx';
import FormModal from 'components/interaction/FormModal/index.jsx';
import EditButton from 'components/interaction/EditButton.js';
import { idValues } from 'utils/arrays.js';
import useSchoolSettings from '../../hooks/useSchoolSettings.js';
import messages from './messages.js';
import schema from './form.js';

function DataProtectionOfficer() {
  const [show, setShow] = useState(null);
  const { settings, changeDpo } = useSchoolSettings();
  const { dataProtectionOfficers } = settings;
  const dataProtectionOfficer = idValues(dataProtectionOfficers)[0];
  const handleSubmit = (data) => changeDpo(dataProtectionOfficer ? { id: dataProtectionOfficer.id, ...data } : data);
  return (
    <div>
      <h3><FormattedMessage {...messages.dataProtectionOfficer} /></h3>
      <p className="form-text"><FormattedMessage {...messages.dataProtectionOfficerIntro} /></p>
      <div className="">
        {dataProtectionOfficer ? (
          <>
            <span>
              <Sanitize>{dataProtectionOfficer.name}</Sanitize>
              {', '}
              <Sanitize className="text-break">{dataProtectionOfficer.email}</Sanitize>
            </span>
            <EditButton className="fs-3 ms-3" onClick={() => setShow(true)} />
          </>
        ) : (
          <Button variant="light" onClick={() => setShow(true)}>
            <FormattedMessage {...messages.setDataProtectionOfficer} />
          </Button>
        )}
      </div>
      <FormModal
        show={show}
        onHide={() => setShow(false)}
        onSubmit={handleSubmit}
        values={dataProtectionOfficer || {}}
        title={messages.dataProtectionOfficer}
        schema={schema}
      />
    </div>
  );
}

// DataProtectionOfficer.propTypes = {
// };

export default DataProtectionOfficer;
